import usePagination from "@mui/material/usePagination/usePagination"
import { List } from "@mui/material"
import {
  gridPageCountSelector,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid"

import Icon from "@/components/icon/Icon"
import BasicButton from "@/components/button/BasicButton"
import IconButton from "@/components/button/IconButton"
import { colorTokens } from "@/components/colorTokens"

import "./Pagination.scss"

// Community DataGrid 는 페이지네이션이 강제(페이지당 최대 100행)라, 페이지 UI 를
// 숨긴 표는 101행째부터 조용히 잘린다. 평소에는 푸터가 없어야 하는 표(리포트 PDF
// 캡처 영역 등)는 이 슬롯으로 100행을 넘을 때만 페이지 UI 를 노출한다.
export const COMMUNITY_GRID_PAGE_SIZE = 100
export const overflowPagination = (rowCount: number) =>
  rowCount > COMMUNITY_GRID_PAGE_SIZE ? Pagination : () => null

export default function Pagination() {
  const apiRef = useGridApiContext()
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector)

  const currentPage = paginationModel.page

  const { items } = usePagination({
    count: pageCount,
    page: (currentPage || 0) + 1,
    onChange: (_, page) => {
      apiRef.current.setPage(page - 1)
    },
  })

  return (
    <nav>
      <List>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null

          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = (
              <Icon
                className="ellipsis"
                type="more-line"
                size={20}
                color={colorTokens.icon.default}
              />
            )
          } else if (type === "page") {
            children = (
              <BasicButton
                className={items.length > 3 && selected ? "selected" : ""}
                size="xs"
                type="ghost"
                {...item}
                disabled={items.length === 3}>
                {page}
              </BasicButton>
            )
          } else if (type === "previous" || type === "next") {
            children = (
              <IconButton
                size="xs"
                type="ghost"
                icon={type === "previous" ? "arrow-left" : "arrow-right"}
                color={item.disabled ? colorTokens.icon.disabled : colorTokens.icon.default}
                {...item}></IconButton>
            )
          }

          return <li key={index}>{children}</li>
        })}
      </List>
    </nav>
  )
}
